/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apikeys_Delete_Api_Key_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to delete API key. Please try again." |
*
* @param {Apikeys_Delete_Api_Key_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const apikeys_delete_api_key_error = /** @type {((inputs?: Apikeys_Delete_Api_Key_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apikeys_Delete_Api_Key_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Löschen des API-Schlüssels. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to delete API key. Please try again.")
});